import React from 'react'
import { useOutlet } from 'react-router-dom'

import { TemplateActions } from './components/template-actions.tsx'
import { TemplatePaymentsTable } from './template-payments-table.tsx'

export const TemplatePaymentsPage = (): React.ReactElement => {
  const outlet = useOutlet()
  if (outlet) return outlet

  return (
    <>
      <TemplateActions />
      <TemplatePaymentsTable />
    </>
  )
}
